import { IoIosMore } from "react-icons/io";
import { useDispatch } from "react-redux";
import { fetchReview } from "../../redux/slices/reviewSlice";
import { useEffect } from "react";
import ResponsivePagination from 'react-responsive-pagination';
import Rating from '@mui/material/Rating';
import Loader from "../Loader";
import { FormattedData } from "../../utils/FormattedData";

const ReviewTable = ({ onRowClick, searchTerm, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  const dispatch = useDispatch();
  const totalPages = Math.ceil(totalRecord / itemsPerPage);

  useEffect(() =>{
      dispatch(fetchReview())
  }, [dispatch]);

  return (
    <div>
      <div className="mt-6 overflow-x-auto sm:-px-6 lg:-px-8 rounded-lg border border-primaryGray border-t-0">
        <div className="inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 table-auto px-3">
            <thead className="bg-orange">
              <tr>
                <th scope="col" className="whitespace-nowrap py-3.5 pl-3 text-left text-sm font-bold text-gray-900">
                  S/N
                </th>
                <th scope="col" className="whitespace-nowrap py-3.5  pl-3 text-left text-sm font-bold capitalize text-gray-900">
                entity
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-center text-sm font-bold capitalize text-gray-900">
                food /agent name (I.D)
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-sm text-center font-bold capitalize text-gray-900">
                rating
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                review summary
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                review made by
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                  <Loader />
                ): data && data.length > 0 ? (
                data && data.map((item, index) => (
                <tr key={item.id} className="border-b border-b-primaryGray cursor-pointer" onClick={() => onRowClick(item)}>
                  <td className="whitespace-nowrap px-3 text-sm text-black capitalize">{index + 1}</td>
                  <td className="whitespace-nowrap px-3 text-sm text-black capitalize font-sembold text-left">
                    {item?.entity}
                  </td>
                  <td className="whitespace-nowrap px-3 text-sm text-center font-semibold text-black capitalize">{item?.foodOrAgentName}</td>
                  <td className="whitespace-nowrap px-3 py-3 text-sm grid place-items-center text-center capitalize">
                  <Rating name="read-only" value={item.rating} readOnly />
                  </td>
                  <td className="px-3 text-sm text-left text-black font-semibold">{FormattedData(item?.reviewSummary)}</td>
                  <td className="whitespace-nowrap px-3 text-sm text-black capitalize">{FormattedData(item?.reviewedBy)}</td>
                  <td className="whitespace-nowrap px-3 text-sm text-[#B3B3B3] text-center">{<IoIosMore />}</td>
                </tr>
              )))
              : <p className="text-primaryRed text-sm text-center py-4">No Reviews</p>
              }
            </tbody>
          </table>
        </div>
      </div>
      <nav className="grid place-items-center mt-10">
        <ResponsivePagination
          current={currentPage}
          total={totalPages}
          onPageChange={setCurrentPage}
          extraClassName="custom-pagination"
          />
      </nav>    
    </div>
  );
};

export default ReviewTable;
